// src/config/apiEndPoints.js
const isDev = process.env.NODE_ENV === 'development';
const API_BASE_URL_2020 = !isDev
  ? 'https://results.mathrubhumi.com/result/lsg2020'
  : 'http://localhost:3001/api';
const API_BASE_URL_2025 = !isDev
  ? 'https://results.mathrubhumi.com/result/lsg2025'
  : 'http://localhost:3001/api';
const TEXT_BASE_URL = !isDev
  ? 'https://results.mathrubhumi.com/result/panchayat/text'
  : 'http://localhost:3001/text';

const ENDPOINTS = {
  STATE_WIDE_2020: !isDev
    ? `${API_BASE_URL_2020}/State.json`
    : `${API_BASE_URL_2020}/state-2020`,
  STATE_WIDE_2025: !isDev
    ? `${API_BASE_URL_2025}/State.json`
    : `${API_BASE_URL_2025}/state-2025`,
  DISTRICT_WISE_2020: !isDev
    ? `${API_BASE_URL_2020}/districts/Trivandrum.json`
    : `${API_BASE_URL_2020}/district-2020/Trivandrum`,
  DISTRICT_WISE_2025: !isDev
    ? `${API_BASE_URL_2025}/districts/Trivandrum.json`
    : `${API_BASE_URL_2025}/district-2025/Trivandrum`,
  LIVE_UPDATES: !isDev
    ? `${API_BASE_URL_2025}/latest.json`
    : `${API_BASE_URL_2025}/latest`,
  TRENDS: !isDev
    ? 'https://results.mathrubhumi.com/result/ACF2021/json/element364.json'
    : `${API_BASE_URL_2025}/trends`,
  CORP_TEXT: !isDev
    ? `${TEXT_BASE_URL}/corp.txt`
    : `${TEXT_BASE_URL}/corp`,
  JILA_TEXT: !isDev
    ? `${TEXT_BASE_URL}/jila.txt`
    : `${TEXT_BASE_URL}/jila`,
  DISTRICTS_TEXT: !isDev
    ? `${TEXT_BASE_URL}/districts.txt`
    : `${TEXT_BASE_URL}/districts`,
  MUNICIPALITY_TEXT: (district) => `${TEXT_BASE_URL}/${district}/muncipality${isDev ? '' : '.txt'}`,
  BLOCK_PANCHAYATH_TEXT: (district) => `${TEXT_BASE_URL}/${district}/blockpanchayath${isDev ? '' : '.txt'}`,
  GRAMA_PANCHAYATH_TEXT: (district) => `${TEXT_BASE_URL}/${district}/gramapanchayath${isDev ? '' : '.txt'}`,
  ELECTION_DATA_2025: (id) => !isDev
    ? `${API_BASE_URL_2025}/local/${id}.json`
    : `${API_BASE_URL_2025}/election-data-2025/${id}`,
  ELECTION_DATA_2020: (id) => !isDev
    ? `${API_BASE_URL_2020}/local/${id}.json`
    : `${API_BASE_URL_2020}/election-data-2020/${id}`,
  PARTYWISE_STATE_2025: !isDev
    ? `${API_BASE_URL_2025}/total/partywise_state.json`
    : `${API_BASE_URL_2025}/partywise-state`,
  PARTYWISE_2025: (id) => !isDev
    ? `${API_BASE_URL_2025}/total/${id}.json`
    : `${API_BASE_URL_2025}/partywise/${id}`,
};

export default ENDPOINTS;